/**
 * @generated SignedSource<<36c48388fa0b9d9ee5ed7ad070439715>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OwnerSecuredVariableInput = {
  clientMutationId: string;
  ownerUid: string;
  platform: string;
  valueToSecure: string;
};
export type OwnerSecuredVariablesMutation$variables = {
  input: OwnerSecuredVariableInput;
};
export type OwnerSecuredVariablesMutation$data = {
  readonly securedOwnerVariable: {
    readonly variableName: string;
  };
};
export type OwnerSecuredVariablesMutation = {
  response: OwnerSecuredVariablesMutation$data;
  variables: OwnerSecuredVariablesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "OwnerSecuredVariablePayload",
    "kind": "LinkedField",
    "name": "securedOwnerVariable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "variableName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OwnerSecuredVariablesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OwnerSecuredVariablesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec2259643403a6991814077fb25ba366",
    "id": null,
    "metadata": {},
    "name": "OwnerSecuredVariablesMutation",
    "operationKind": "mutation",
    "text": "mutation OwnerSecuredVariablesMutation(\n  $input: OwnerSecuredVariableInput!\n) {\n  securedOwnerVariable(input: $input) {\n    variableName\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9ee6cd324b3443ac8328dd40b969b63";

export default node;
